import classNames from "classnames/bind";
import type { ResolvedQuotation } from "resolvers/data/quotationResolver";

import styles from "./Quotation.module.scss";

const cx = classNames.bind(styles);

const Quotation = (props: ResolvedQuotation) => {
    const { text, color, isBold, isUnderlined, isItalic, fontSize, author } = props;
    return (
        <>
            <blockquote
                className={cx("quotation", { isBold, isUnderlined, isItalic })}
                style={{
                    color,
                    fontSize,
                    lineHeight: 1.25,
                }}
            >
                {text}
            </blockquote>
            {author && (
                <p className={cx("author")} style={{ color }}>
                    {author}
                </p>
            )}
        </>
    );
};

export default Quotation;
